var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 6.1875H3.75C3.60082 6.1875 3.45774 6.24676 3.35225 6.35225C3.24676 6.45774 3.1875 6.60082 3.1875 6.75V20.25C3.1875 20.3992 3.24676 20.5423 3.35225 20.6477C3.45774 20.7532 3.60082 20.8125 3.75 20.8125H17.25C17.3992 20.8125 17.5423 20.7532 17.6477 20.6477C17.7532 20.5423 17.8125 20.3992 17.8125 20.25V6.75C17.8125 6.60082 17.7532 6.45774 17.6477 6.35225C17.5423 6.24676 17.3992 6.1875 17.25 6.1875ZM16.6875 19.6875H4.3125V7.3125H16.6875V19.6875ZM20.8125 3.75V17.25C20.8125 17.3992 20.7532 17.5423 20.6477 17.6477C20.5423 17.7532 20.3992 17.8125 20.25 17.8125C20.1008 17.8125 19.9577 17.7532 19.8523 17.6477C19.7468 17.5423 19.6875 17.3992 19.6875 17.25V4.3125H6.75C6.60082 4.3125 6.45774 4.25324 6.35225 4.14775C6.24676 4.04226 6.1875 3.89918 6.1875 3.75C6.1875 3.60082 6.24676 3.45774 6.35225 3.35225C6.45774 3.24676 6.60082 3.1875 6.75 3.1875H20.25C20.3992 3.1875 20.5423 3.24676 20.6477 3.35225C20.7532 3.45774 20.8125 3.60082 20.8125 3.75Z",
    fill: "#404D6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.007066e6780d4c8502eaa22b1875ce19.svg";
export { ForwardRef as ReactComponent };